import axios from "axios";

const apiURL = process.env.REACT_APP_API_ENDPOINT;

/*Change Get Api here*/
const getApiManageNetwork = async (query) => {
  return axios({
    method: "get",
    url: `${apiURL}/networks?page=1&limit=100`,
    params: query,
  });
};

export { getApiManageNetwork };
